module.exports = __webpack_public_path__ + "img/sign_out.782f9932.svg";